/* ============================================================
   ILEV · ETIQUETA DE PREVENTA EN EL CARRITO  (25-sep-2026 · 25-sep tarde: despacho el LUNES 5-oct y Tónico de Barba en preventa)
   ------------------------------------------------------------
   En cada línea del carrito (panel lateral y página /cart):
     · Bomba 30 cáps, DÚO 30 días y Tónico de Barba → «🚚 Preventa ·
       despacho desde el lunes 5 de octubre»
     · Bomba 90 cáps, DÚO 3 meses y TRÍOs → «⚡ Despacho inmediato»
   Así el cliente ve la fecha ANTES de pagar, no solo en la ficha.
   Se apaga sola el 5-oct 00:00 (hora de Chile).
   Lo carga snippets/ilev-carrito-carga.liquid.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ilevPvCarrito) return;
  window.__ilevPvCarrito = true;

  var FIN = Date.parse('2026-10-05T00:00:00-03:00');
  if (Date.now() >= FIN) return;

  var PREVENTA = ['7654109053109', '7824586670261', '8253567008949',  /* Bomba 30 · DÚO 30 días · Tónico de Barba */
                  '10240376111285'];                                  /* TRÍO + Barba de regalo (trae Tónico de Barba) */
  var INMEDIATO = ['10613330804917', '8071928643765', '8211753697461', /* Bomba 90 · DÚO 3 meses · TRÍO */
                   '10240372277429'];                                 /* TRÍO + Sérum */

  var st = document.createElement('style');
  st.textContent =
    '.ilev-li-pv{display:inline-block;margin:4px 0 2px;padding:3px 9px;border-radius:999px;font-size:11px;font-weight:700;' +
      'line-height:1.25;letter-spacing:.01em;background:#F0F8F9;border:1px solid #B6DCE1;color:#4B384C}' +
    '.ilev-li-pv--hoy{background:#4B384C;border-color:#4B384C;color:#fff}';
  document.head.appendChild(st);

  function marcar() {
    document.querySelectorAll('[data-js-cart-item][data-product-id]').forEach(function (it) {
      if (it.querySelector('.ilev-li-pv')) return;
      if (it.classList.contains('cart-item--gratis')) return;          /* regalos: sin etiqueta */
      var pid = it.getAttribute('data-product-id');
      var txt = null, hoy = false;
      if (PREVENTA.indexOf(pid) > -1) txt = '🚚 Preventa · despacho desde el lunes 5 de octubre';
      else if (INMEDIATO.indexOf(pid) > -1) { txt = '⚡ Despacho inmediato'; hoy = true; }
      if (!txt) return;
      var s = document.createElement('span');
      s.className = 'ilev-li-pv' + (hoy ? ' ilev-li-pv--hoy' : '');
      s.textContent = txt;
      var titulo = it.querySelector('.cart-item__title');
      if (titulo && titulo.parentNode) titulo.parentNode.insertBefore(s, titulo.nextSibling);
    });
  }

  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(marcar, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
  marcar();
})();
